function updateCountdown() {
  const now = new Date();
  const countdownEndTime = new Date($('[data-countdown-end-time]').data('countdown-end-time'));
  const nextMidnight = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
    0, 0, 0
  );

  let diff = nextMidnight - now;
  if (countdownEndTime != null && countdownEndTime > now) {
    diff = countdownEndTime - now;
  }
  let seconds = Math.floor(diff / 1000);
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;

  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return {
    hh, mm, ss
  }
}

setInterval(() => {
  const result = updateCountdown()
  // set to DOM
  const $countdownTimer = $('.countdown-timer');
  $countdownTimer.find('.hours').text(result.hh);
  $countdownTimer.find('.minutes').text(result.mm);
  $countdownTimer.find('.seconds').text(result.ss);
},1200)